import React from "react";
import { Button } from "react-bootstrap";
import { FaArrowUp } from "react-icons/fa";
import "./TopBar.css";

const TopBar = () => {

  const handleScrollTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  };

  return (
    <div className="skilledition-topbar-wrapper">
      <Button
        className="skilledition-topbar-btn"
        onClick={handleScrollTop}
      >
        <FaArrowUp className="skilledition-topbar-icon" />
      </Button>
    </div>
  );
};

export default TopBar;
